import { objectSchema } from "vue-utils"
import { extend, type Id, type Nullable } from "./GenericEntity"
import { PagedResult, type PagedRequest } from "./Paged"
import { ShipmentLog } from "./ShipmentLog"
import type { ShipmentStatus } from "./ShipmentStatus"
import type { SortDirection } from "./Sorting"
import { TFSEntryMetadata } from "./TFSEntry"

export interface SearchShipmentsRequest extends PagedRequest {
	tfsId: Id
	filter: SearchShipmentsFilter
	sortBy: SearchShipmentsSortBy
	sortDirection: SortDirection
}

export interface SearchShipmentsFilter {
	statuses: ShipmentStatus[]
	hasRecoveryAtFacility: Nullable<boolean>
	hasAdditionalDocuments: Nullable<boolean>
}

export enum SearchShipmentsSortBy {
	ShipmentNumber = "ShipmentNumber",
	Status = "Status",
	DateCreated = "DateCreated",
	ShipmentDate = "ShipmentDate",
	NotificationsOfShipment = "NotificationsOfShipment",
	RecoveryAtFacility = "RecoveryAtFacility",
	AdditionalDocuments = "AdditionalDocuments",
	Completed = "Completed",
	Cancelled = "Cancelled",
}

export interface SearchShipmentsResult extends PagedResult {
	globalTotal: number
	tfsMetadata: TFSEntryMetadata
	logs: ShipmentLog[]
}
export const SearchShipmentsResult = objectSchema<SearchShipmentsResult>({
	...extend(PagedResult),
	globalTotal: Number,
	tfsMetadata: TFSEntryMetadata,
	logs: ShipmentLog.array(),
})
